import { normalize, schema } from 'normalizr'
import {
  Id,
  IStationUserInvite,
  IStateOrganizationTeamMember,
  StateOrganizationTeamMemberMap,
  IStationUserUpdateDTO,
  IMemberFilters,
  IStationUserSearchObject,
  IZoneObject,
  IStationUserZoneObject
} from '../types'
import Paths from '../utils/paths'
import { serverApi } from '../utils/request'

function serializeStationUser(member: IStateOrganizationTeamMember): IStationUserSearchObject {
  const email = member.user.email ? member.user.email.emailAddress : ''
  const phoneObj = member.user.phones ? member.user.phones[0] : null
  const phone = phoneObj ? `${phoneObj.phoneNumber}` : ''
  const birthDate = member.user.birthDate ? new Date(member.user.birthDate).toISOString() : new Date().toISOString()
  return {
    id: member.id,
    userId: member.user.id,
    name: `${member.user.firstName} ${member.user.lastName}`,
    firstName: member.user.firstName,
    lastName: member.user.lastName,
    isArchived: member.isArchived,
    isActive: member.user.isActive,
    status: member.status,
    organizationId: member.organizationId,
    organizationName: member.organization.name,
    email,
    phone,
    countryCode: phoneObj.countryCode || '1',
    username: member.user.username,
    birthDate
  }
}

class StationUserService {
  //   public static usersSchema = new schema.Entity('users')
  //   public static rolesSchema = new schema.Entity('roles')
  //   public static organizationsSchema = new schema.Entity('organizations')
  //   public static stationUser = new schema.Entity('teamMembers', {
  //     user: StationUserService.usersSchema,
  //     roles: [StationUserService.rolesSchema],
  //     organization: StationUserService.organizationsSchema
  //   })

  public async fetchStationUserList(dto: IMemberFilters) {
    const resp: any = await serverApi.get(Paths.stationUser.search, {
      params: { search: dto.search, isArchived: dto.isArchived }
    })
    return resp.data
  }

  public async fetchByUserId(userId: string) {
    const resp: any = await serverApi.get(Paths.stationUser.getByUserId, {
      params: { userId }
    })
    return resp.data
  }

  public async fetchStationUser(id: Id): Promise<IStationUserSearchObject> {
    const teamMember: any = await serverApi.get(`${Paths.stationUser.base}/${id}`)
    return serializeStationUser(teamMember.data as IStateOrganizationTeamMember)
  }

  // Invite actually calls for createOne

  public async createStationUser(teamMember: IStationUserInvite): Promise<IStationUserSearchObject> {
    try {
      const teamMembersResponse = await serverApi.post<IStateOrganizationTeamMember>(
        Paths.stationUser.createStationUser,
        teamMember
      )
      return serializeStationUser(teamMembersResponse.data)
    } catch (e) {
      throw e.data
    }
  }

  public async updateOneStationUser(stationUser: IStationUserUpdateDTO): Promise<any> {
    const resp = await serverApi.put<IStateOrganizationTeamMember>(Paths.stationUser.update, stationUser)

    return serializeStationUser(resp.data)
  }

  public moveToArchiveStationUser(teamMember: IStationUserSearchObject): Promise<any> {
    return serverApi.post(Paths.stationUser.archieve, {
      userId: teamMember.userId,
      organizationId: teamMember.organizationId
      // roles: []
    })
  }
  public restoreFromArchive(teamMember: IStationUserSearchObject): Promise<IStateOrganizationTeamMember> {
    // TODO: replace with a request
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(teamMember as any)
        // reject('error!!!')
      }, 1000)
    })
  }
  public sendInviteStationUser(teamMember: IStationUserSearchObject): Promise<any> {
    return serverApi.post(Paths.user.resendInvitation, {
      userId: teamMember.userId,
      organizationId: teamMember.organizationId
    })
  }

  public async getGoinzones(stationUserId: string) {
    const result = await serverApi.get(`${Paths.stationUser.getZone}/${stationUserId}`)
    const data: IStationUserZoneObject[] = result.data as IStationUserZoneObject[]

    return data
  }
  public async createGoinzone(dto: IStationUserZoneObject) {
    return await serverApi.post(Paths.stationUser.createOrUpdateZone, dto)
  }

  public async removeGoinzone(stationUserId: string) {
    return await serverApi.delete(`${Paths.stationUser.getZone}/${stationUserId}`)
  }

  public async updateGoinzone(dto: any) {
    return await serverApi.patch(Paths.stationUser.createOrUpdateZone, dto)
  }
}

const stationUserService = new StationUserService()

export { stationUserService }



// WEBPACK FOOTER //
// ./src/services/StationUser.ts